import { BoltPromptCommand } from './models/BoltPromptCommand';
import { UserPromptCommand } from './models/UserPromptCommand';
import type { AnyCommand, AnyPromptCommand } from './types';

export function isPromptCommand(command: AnyCommand): command is AnyPromptCommand {
  return command instanceof BoltPromptCommand || command instanceof UserPromptCommand;
}
